import { CHANNELS } from "../../shared/channels";
import { UserSettings } from "../../shared/types";
import { call } from "../bridge";
import { byId } from "../dom";
import { t } from "../i18n";

// settings buttons that run one long action in the main process and report back

interface ActionButton {
  buttonId: string;
  channel: string;
  waitingText: string;
  doneText: (result: string) => string;
}

const actions: ActionButton[] = [
  {
    buttonId: "settings-plane-connect",
    channel: CHANNELS.planeConnect,
    waitingText: "talking to plane",
    doneText: (workspace) => t("connected to {workspace}, now pick your boards", { workspace })
  }
];

export function setupSettingsActions(afterAction: () => Promise<void>): void {
  for (const action of actions) {
    byId(action.buttonId).addEventListener("click", async () => {
      const status = byId("settings-status");
      if (action.channel === CHANNELS.planeConnect && !window.bridge) {
        const settings = await call<UserSettings>(CHANNELS.settingsGet);
        const url = settings.planeUrl || "https://plane.fractalstella.com";
        window.open(url, "_blank", "noopener");
        status.replaceChildren();
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener";
        link.textContent = t("open plane");
        status.append(link, document.createTextNode(` ${t("in safari, create an api token in profile settings, paste it below, then save")}`));
        return;
      }
      status.textContent = t(action.waitingText);
      try {
        const result = await call<string>(action.channel);
        status.textContent = action.doneText(result);
        await afterAction();
      } catch (error) {
        status.textContent = String(error).replace(/^Error: Error invoking remote method '[^']+': /, "");
      }
    });
  }
}
